import { useMemo, type ReactNode } from 'react';
import { useSidebarFavourites } from '../favouritesStore';
import { PanelFavouritesContext } from './favouritesContext';

/** Scopes the star toggles and the Favourites section beneath it to one panel. */
export function PanelFavouritesProvider({
  panelId,
  children,
}: {
  panelId: string;
  children: ReactNode;
}) {
  const { items, toggle } = useSidebarFavourites(panelId);
  const value = useMemo(() => {
    const ids = new Set(items.map((f) => f.id));
    return { items, toggle, isFavourite: (id: string) => ids.has(id) };
  }, [items, toggle]);
  return (
    <PanelFavouritesContext.Provider value={value}>{children}</PanelFavouritesContext.Provider>
  );
}
